var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 3.33334L14 6.66667L10.6667 10",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.81667C14.4694 5.81667 14.85 6.19723 14.85 6.66667C14.85 7.13611 14.4694 7.51667 14 7.51667V5.81667ZM2.85 14V14.85H1.15V14H2.85ZM14 7.51667H8.66667V5.81667H14V7.51667ZM8.66667 7.51667C5.45411 7.51667 2.85 10.1208 2.85 13.3333H1.15C1.15 9.1819 4.51523 5.81667 8.66667 5.81667V7.51667ZM2.85 13.3333V14H1.15V13.3333H2.85Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f4bf2e577ec8ebc0df2263beaaa33357.svg";
export { ForwardRef as ReactComponent };